import { render } from "./HeroiconsOutlineX.vue?vue&type=template&id=a0da7b76"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineX.vue"]])

export default __exports__